<span class="tooltipCustom"
      [class.bottom]="bottom"
      data-tooltip
      data-allow-html="true"
      tabindex="1"
      [title]="title" #el>
    <ng-content></ng-content>
</span>
